export const isDesktop = window.innerWidth >= 768;
